"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderClaims = void 0;
const confirmation_modal_1 = require("client/components/confirmation-modal");
const button_1 = require("client/components/material/button");
const checkbox_1 = require("client/components/material/checkbox/checkbox");
const date_picker_1 = require("client/components/material/date-picker/date-picker");
const list_1 = require("client/components/material/list");
const list_item_1 = require("client/components/material/list/list-item");
const list_item_text_1 = require("client/components/material/list/list-item/list-item-text");
const menu_1 = require("client/components/material/menu");
const select_1 = require("client/components/material/select");
const text_field_1 = require("client/components/material/text-field");
const modal_1 = require("client/components/modal");
const router_1 = require("client/components/router");
const ui_1 = require("client/components/ui"); // B-094.12
const alert_1 = require("client/components/ui/alert");
const multi_select_1 = require("client/components/ui/multi-select");
const store_1 = require("client/modules/inventory-order/store");
const store_2 = require("client/modules/inventory/modules/inventory-list/store");
const store_3 = require("client/modules/orders/store");
const store_4 = require("client/modules/patients/store");
const store_5 = require("client/modules/providers/store");
const store_6 = require("client/modules/sites/modules/sites-detail/store");
const store_7 = require("client/modules/store");
const store_8 = require("client/modules/users/store");
const material_ui_1 = require("material-ui");
const MoreVert_1 = require("material-ui-icons/MoreVert");
const Warning_1 = require("material-ui-icons/Warning");
const Menu_1 = require("material-ui/Menu");
const Collapse_1 = require("material-ui/transitions/Collapse");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const moment = require("moment-timezone");
const ramda_1 = require("ramda");
const React = require("react");
const react_1 = require("react");
const ReactTooltip = require("react-tooltip");
const claim_1 = require("shared/claim");
const order_1 = require("shared/order");
const permissions_1 = require("shared/permissions");
const uppercase_string_1 = require("shared/util/uppercase-string");
require("./order-claims.less");
const transaction_details_1 = require("./transaction-details");
const midLevelTitle = ["APRN", "NP", "PA", "RN"];
let OrderClaims = class OrderClaims extends react_1.Component {
    constructor() {
        super(...arguments);
        this.rendered = false;
        this.changedClaims = [];
        this.menuOpen = {};
        this.showChildren = {};
        this.isCollapse = true;
        this.checkedClaimId = -1;
        this.editClaimId = -1;
        this.currentRowIndex = -1;
        this.order = "ASC";
        this.orderBy = "claim.inventory.package";
        this.showClaimResponse = false;
        this.selectedRefill = null;
        this.findAlternative = false;
        this.selectedAlternative = null;
        this.expireDate = null;
        this.erxLogData = []; //B-096.2
        this.claimLots = [];
        this.createLotShow = false;
        this.onRetryCLaim = true; // B-094.12
        this.newLot = {
            expireDate: new Date(),
            lotNumber: "",
            quantity: 0
        };
        this.columns = [
            {
                id: "rxId.rxId",
                // id: "claim.rxId.rxId"
                label: "rx-fill #".toUpperCase()
            },
            {
                id: "inventory.priority",
                label: "priority".toUpperCase()
            },
            {
                id: "inventory.package",
                label: "ndc".toUpperCase()
            },
            {
                id: "inventory.name",
                label: "Name".toUpperCase()
            },
            {
                id: "claim.quantity",
                label: "pkg qty".toUpperCase()
            },
            {
                id: "status",
                label: "status".toUpperCase()
            },
            {
                id: "NO_ACTION",
                label: "".toUpperCase()
            }
        ];
        this.renderedGroups = 0;
        this.settings = {
            insurance: "",
            isCash: "1"
        };
        this.isCash = "";
        this.insurance = "";
        this.onClickMenu = (event, groupIndex, rowIndex) => {
            this.menuOpen = ramda_1.merge(this.menuOpen, {
                [`${groupIndex}-${rowIndex}`]: event.currentTarget
            });
        };
        /**
       * get erx data while click on view claim data. B-096.2
       * function is used to get the each and every ERX tranmission date and time
       */
        this.getErxDataOnView = async (claimId) => {
            var _a;
            this.onRetryCLaim = false; //B-096.2
            let filteredData = [];
            const result = await store_3.ordersStore.readERXLog(claimId); //B-096.2
            const erxLogs = result.value; //B-096.2
            (_a = (erxLogs || [])) === null || _a === void 0 ? void 0 : _a.map((item) => {
                var _a;
                (_a = (erxLogs || [])) === null || _a === void 0 ? void 0 : _a.filter((data) => {
                    if (item.id === data.logReference) {
                        filteredData.push(item, data);
                    }
                });
            });
            this.erxLogData = filteredData || []; //B-096.2
            this.onRetryCLaim = true; // B-096.2
        };
        this.onClickMenuItem = async (claim, groupIndex, rowIndex, itemIndex) => {
            // apply loader on item click bcs prevent to hit the unwanted API hit w/o getting response // B-094.12 
            this.onRetryCLaim = false; // B-094.12
            switch (itemIndex) {
                case 0:
                    await store_3.ordersStore.retryClaim(claim.id);
                    break;
                case 1:
                    if (!this.claimLots.length) {
                        alert("Lot # and Exp. Date must be provided to print labels.");
                        break;
                    }
                    if (this.props.order) {
                        router_1.RouteManager.transitionTo(`/claims/${this.props.order.id}/print-labels/${claim.rxId.rxId}`);
                    }
                    break;
                case 2:
                    await store_3.ordersStore.listErxDataFields();
                    // C-122
                    // await this.getErxDataOnView(claim.id) //B-096.2
                    // this.showClaimResponse = claim;
                    const url = `/claims/${this.props.order.id}?id=${claim.id}&group=${groupIndex}`;
                    window.open(url, "_blank");
                    break;
                case 3:
                    this.selectedRefill = claim;
                    this.confirmRefill();
                    break;
                case 4:
                    await store_3.ordersStore.delayRefillClaim(claim.id);
                    break;
                case 5:
                    await store_3.ordersStore
                        .cancelRefillClaim(claim.id)
                        .then(() => window.open(`/claims/${this.props.order.id}`));
                    break;
                case 6:
                    this.selectedAlternative = claim;
                    this.findAlternative = true;
                    this.confirmFindAlternative();
                    break;
                default:
                    break;
            }
            this.onRetryCLaim = true; // B-094.12
            this.menuOpen = ramda_1.merge(this.menuOpen, {
                [`${groupIndex}-${rowIndex}`]: undefined
            });
        };
        this.handleSelect = (fieldName) => (value) => {
            this.settings[fieldName] = value;
        };
        this.onCloseMenu = (groupIndex, rowIndex) => {
            this.menuOpen = ramda_1.merge(this.menuOpen, {
                [`${groupIndex}-${rowIndex}`]: undefined
            });
        };
        this.handleFindAlternative = async (claimType) => {
            const oldClaim = this.selectedAlternative;
            const { siteId } = oldClaim.order;
            const { providerId } = oldClaim.order;
            const { patientId } = oldClaim.order;
            const groups = [this.selectedAlternative.inventory.group];
            const orderType = claimType;
            const now = moment();
            const runAt = moment(`${now.format("MM/DD/YYYY")} ${now.format("hh:mm a")}`).format();
            await store_6.sitesDetailStore.loadInventories(siteId);
            const inventoryIds = store_6.sitesDetailStore.inventorysites.value
                .filter((ndc) => groups.includes(ndc.inventory.group))
                .map((ndc) => ndc.inventoryId);
            const order = {
                claims: [],
                id: Number(oldClaim.order.id)
            };
            const cancelRefill = await store_3.ordersStore.cancelRefillClaim(this.selectedAlternative.id);
            const cancelOrder = await store_3.ordersStore.dispenseOrder(order);
            const response = await store_3.ordersStore.createOrder(siteId, providerId, oldClaim.insurance, patientId, inventoryIds, orderType, runAt);
            if (!!response && (response === null || response === void 0 ? void 0 : response.order) && cancelOrder) {
                this.findAlternative = false;
                store_3.ordersStore.errorAlert = null;
                router_1.RouteManager.transitionTo(`/claims/${response.order.id}`);
            }
        };
        this.confirmFindAlternative = () => {
            const types = [
                {
                    id: 1,
                    label: "Cash",
                    value: "1"
                },
                {
                    id: 2,
                    label: "Insurance",
                    value: "0"
                }
            ];
            let newSelection = 1;
            const selectClaim = (React.createElement(select_1.MaterialSelect, { options: types, required: true, value: String(newSelection), label: "Claim Type", onSelect: (value) => {
                    newSelection = Number(value);
                } }));
            return (true && (React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: "Confirm", cancelText: "Go Back", message: `You have chosen to find an alternative to
          <b>${this.selectedAlternative.inventory.strengthDescription ||
                    this.selectedAlternative.inventory.name}</b>. This
          process involves several automated steps; please be sure you wish to
          proceed before clicking confirm. This action cannot be undone!
          <ol class="confirm-alternative">
            <li>Current prescription will be cancelled.</li>
            <li>New claim is created for the <i>${this.selectedAlternative.inventory.group}</i> group.</li>
            <li>You will be redirected to the new claim.</li>
            <li>New claim undergoes the adjudication process.</li>
            <li>You will be prompted to dispense a new medication.</li>
          </ol>
          Are you sure you wish to proceed?
        </p>
        `, addinModal: selectClaim, onCancel: () => {
                    this.findAlternative = false;
                }, onConfirm: async () => {
                    await this.handleFindAlternative(newSelection);
                }, title: "Find Alternative Medication" })));
        };
        /**
         * @Description Verifies that a refill should be cash or insurance when selected.
         * If confirmed, it passes the refill with the new option, if canceled it returns the option to null.
         */
        this.confirmRefill = () => {
            const insurances = this.patient &&
                this.patient.insurances.map((insurance) => ({
                    id: insurance.id,
                    label: insurance.insuranceId,
                    value: insurance.id
                }));
            const claimType = this.selectedRefill.order.type === 0 ? "insurance" : "cash";
            // this.settings.isCash = claimType === "cash" ? "1" : "0";
            this.isCash = claimType === "cash" ? "1" : "0";
            const drugName = this.selectedRefill.order.name;
            const types = [
                {
                    id: 1,
                    label: "Cash",
                    value: "1"
                },
                {
                    id: 2,
                    label: "Insurance",
                    value: "0"
                }
            ];
            const selectClaim = () => (React.createElement("div", null,
                insurances.length ? (React.createElement(select_1.MaterialSelect, { options: types, required: true, value: this.settings.isCash, label: "Claim Type", onSelect: this.handleSelect("isCash") })) : ("Missing Insurance - Must Be Cash"),
                this.settings.isCash === "0" && (React.createElement(select_1.MaterialSelect, { options: insurances, required: true, value: this.settings.insurance, label: "Insurance Card", onSelect: this.handleSelect("insurance") }))));
            const fillRefill = async (claim) => {
                this.selectedRefill = null;
                const order = await store_3.ordersStore.refillClaim(
                // question for Matt: this creates and new order and then redirects to that order in the site. When does it send the request to erx, to actually create new claims? on redirect?
                claim.id, Number(claim.order.type), Number(this.settings.insurance));
                if (order) {
                    router_1.RouteManager.transitionTo(`/claims/${order.id}`);
                }
            };
            return (React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: "Process Refill", cancelText: "Go Back", message: `You are about to place a refill for ${drugName}.
        <p>
          This prescription was previously paid for with <strong>${claimType.toUpperCase()}</strong>.
          Please confirm the claim type for <em>this</em> refill.
        </p>
        `, addinModal: selectClaim(), shouldDisableConfirm: this.settings.isCash === "0" && !Boolean(this.settings.insurance), onCancel: () => {
                    this.selectedRefill = null;
                }, onConfirm: async () => {
                    this.selectedRefill.order.type = this.settings.isCash;
                    await fillRefill(this.selectedRefill);
                }, title: "Confirm Refill Payment" }));
        };
        this.calculateNominalQty = () => {
            const siteId = this.claim.order.site.id;
            const siteInventory = this.claim.inventory.sites.find(inventorySite => inventorySite.siteId === siteId &&
                inventorySite.inventoryId === this.claim.inventory.id);
            const expiredLots = (siteInventory === null || siteInventory === void 0 ? void 0 : siteInventory.inventorySiteLots) ? siteInventory.inventorySiteLots.filter((invSiteLot) => {
                const expDate = moment(invSiteLot.expirationDate);
                const expired = moment().isAfter(expDate);
                return expired;
            })
                : [];
            const inventorysiteQuantity = siteInventory ? siteInventory.quantity : 0;
            const totalExpiredLotsQty = expiredLots.reduce((cur, acc) => {
                if (acc === null || acc === void 0 ? void 0 : acc.quantity) {
                    return cur + Number(acc.quantity);
                }
                return cur;
            }, 0);
            const inventorysiteQuantityNominal = inventorysiteQuantity - totalExpiredLotsQty;
            return {
                inventorysiteQuantity,
                inventorysiteQuantityNominal,
                totalExpiredLotsQty
            };
        };
        this.renderClaimInfo = (claim) => {
            var _a;
            const editMode = claim.status === claim_1.ClaimStatus.Paid;
            const matchedClaim = this.changedClaims.find(c => c.id === claim.id);
            const claimLots = matchedClaim ? matchedClaim.claimLots : claim.claimLots;
            const selectedClaimLots = (claimLots === null || claimLots === void 0 ? void 0 : claimLots.length) ? claimLots.map((claimLot) => {
                // If siteLot exists, it means the page was refreshed and claim lot is from the db
                // so we need to formulate the interface for the select values.
                if (claimLot.siteLot) {
                    return {
                        claimLot,
                        id: claimLot.siteLot.id,
                        label: `${claimLot.siteLot.lotNumber}`,
                        value: JSON.stringify(claimLot.siteLot)
                    };
                }
                return {
                    id: claimLot.id,
                    label: claimLot.label,
                    value: claimLot.value
                };
            })
                : [];
            console.info("selectedClaimLots", selectedClaimLots);
            this.claimLots = matchedClaim ? matchedClaim.claimLots : claim.claimLots;
            const { order } = this.props;
            const provider = order === null || order === void 0 ? void 0 : order.provider;
            const providerTitle = provider === null || provider === void 0 ? void 0 : provider.title;
            const site = order === null || order === void 0 ? void 0 : order.site;
            const pic = (_a = order === null || order === void 0 ? void 0 : order.picProvider) !== null && _a !== void 0 ? _a : site === null || site === void 0 ? void 0 : site.picProvider;
            const picName = (pic && `${pic === null || pic === void 0 ? void 0 : pic.firstName} ${pic === null || pic === void 0 ? void 0 : pic.lastName}`) || "None";
            const approvedOrder = order.auditStatus === order_1.AuditStatus.Approved;
            const { totalExpiredLotsQty, inventorysiteQuantity, inventorysiteQuantityNominal } = this.calculateNominalQty();
            const canFill = inventorysiteQuantityNominal >= claim.quantity;
            return (React.createElement("div", { className: "two-rows-container" },
                React.createElement("div", { className: "main" },
                    React.createElement("div", { className: "inventory-name" },
                        React.createElement("h3", null, claim.inventory.strengthDescription ||
                            claim.inventory.name ||
                            claim.inventory.generic),
                        React.createElement("h4", null,
                            claim.inventory.package,
                            " | ",
                            claim.inventory.dosage),
                        React.createElement("span", { className: "inventory-description" }, claim.inventory.description),
                        React.createElement("h5", null,
                            React.createElement("a", { onClick: () => router_1.RouteManager.transitionTo(`../formulary/0/${claim.inventory.id}`) }, "View Details"))),
                    React.createElement("div", { className: "claim-info claim-info__flex-justify" },
                        React.createElement("div", { className: "row" },
                            React.createElement("div", { className: "claim-info__column" },
                                React.createElement("div", { className: "label text" }, "Physician In Charge"),
                                React.createElement("div", { className: "value" }, picName)),
                            React.createElement("div", { className: "claim-info__column" },
                                React.createElement("div", { className: "label text" }, "Qty"),
                                React.createElement("div", { className: "value" }, claim.quantity)),
                            React.createElement("div", { className: "claim-info__column" },
                                React.createElement("div", { className: "label text" }, "Refills Remaining"),
                                React.createElement("div", { className: "value" }, claim.refills - Number(claim.fillNumber)))),
                        order.auditStatus !== order_1.AuditStatus.Unsubmitted && (React.createElement("div", { className: "row" },
                            React.createElement("div", { className: "claim-info__column" },
                                React.createElement("div", { className: "label text" }, "Lot #"),
                                editMode && approvedOrder && canFill ? ([
                                    React.createElement("div", { className: "lot-number-select-container", "data-claim-qty": claim.quantity },
                                        React.createElement("div", { className: "lot-number-select-container__select" },
                                            React.createElement("div", null,
                                                React.createElement(multi_select_1.UiMultiSelect, { className: "claim-lot-multi-select", label: "Lot *", missing: false, 
                                                    // options={this.availableOptions}
                                                    options: this.availableLots, values: selectedClaimLots, onChange: async (values) => {
                                                        await this.onChangeMultiSelect(values);
                                                    } }),
                                                React.createElement("div", { className: "lot-select-preview" }, (selectedClaimLots === null || selectedClaimLots === void 0 ? void 0 : selectedClaimLots.length) ? this.renderClaimLotSelectionPreview(selectedClaimLots)
                                                    : null)),
                                            React.createElement("div", { className: "lot-number-select-container__visual-qty" },
                                                React.createElement(material_ui_1.Typography, { variant: "subheading" }, "Claim Quantity"),
                                                React.createElement(material_ui_1.Typography, { variant: "headline" }, claim.quantity))),
                                        React.createElement(button_1.MaterialButton, { flat: true, onClick: () => {
                                                this.createLotShow = true;
                                            } }, "Create Lot"))
                                ]) : !canFill && claim.status !== claim_1.ClaimStatus.Dispensed ? (React.createElement("div", null,
                                    React.createElement("div", { className: "empty" }, "Not Enough Inventory"),
                                    React.createElement(material_ui_1.Typography, null,
                                        "Inventory qty: ",
                                        inventorysiteQuantity),
                                    React.createElement(material_ui_1.Typography, null,
                                        "Total expired lots qty: ",
                                        totalExpiredLotsQty),
                                    React.createElement(material_ui_1.Typography, null,
                                        "Nominal inventory qty: ",
                                        inventorysiteQuantityNominal),
                                    React.createElement(material_ui_1.Typography, null,
                                        "claim qty: ",
                                        claim.quantity),
                                    React.createElement("br", null),
                                    React.createElement(material_ui_1.Typography, { style: { color: "blue" } }, "This claim will be marked as Intend to Dispense."),
                                    claim.status === claim_1.ClaimStatus.Intended ? (React.createElement(button_1.MaterialButton, { flat: true, secondary: true, onClick: this.handleGenerateQuickOrder(claim) }, "Generate Order")) : null)) : (claim.claimLots &&
                                    claim.claimLots.map(lot => (React.createElement("div", { className: "value" }, lot.siteLot.lotNumber))))),
                            React.createElement("div", null, Number(claim.fillNumber) > 0 && (React.createElement(React.Fragment, null,
                                React.createElement("div", { className: "label text" }, "Originating Prescription"),
                                React.createElement("div", { className: "value" },
                                    React.createElement("a", { style: { color: "cornflowerblue" }, onClick: () => router_1.RouteManager.transitionTo(`/claims/${claim.originalOrderId}`) },
                                        "RX#",
                                        " ",
                                        claim.rxId.rxId.toString().concat("-00") || "Err"))))))))),
                this.createLotShow && this.renderAddLotUi()));
        };
        // multiselect update
        this.onChangeMultiSelect = async (valuesUnfiltered) => {
            const values = valuesUnfiltered.filter((value) => {
                if (value.label.includes("EXPIRED")) {
                    alert("Unable to dispense expired lots.");
                    return false;
                }
                return true;
            });
            const siteId = this.claim.order.site.id;
            const siteInventory = this.claim.inventory.sites.find(inventorySite => inventorySite.siteId === siteId &&
                inventorySite.inventoryId === this.claim.inventory.id);
            const newClaimLots = siteInventory.inventorySiteLots
                .filter((invSiteLot) => values.some((value) => value.id === invSiteLot.id))
                .map((invSiteLot) => {
                const valueFound = values.find(value => value.id === invSiteLot.id);
                return Object.assign(Object.assign({}, valueFound.claimLot), { siteLot: invSiteLot });
            });
            const fieldName = "claimLots";
            this.claim = ramda_1.merge(this.claim, {
                [fieldName]: newClaimLots
            });
            this.updateChangedClaims(this.claim);
            this.props.handleClaimChanged(this.changedClaims);
            await this.saveClaim(this.claim);
        };
        this.handleGenerateQuickOrder = (claim) => async () => {
            const { order, inventory, quantity: claimQuantity } = claim;
            const { site } = order;
            const generateIntentOrderMeta = {
                claim,
                claimQuantity,
                inventory,
                site
            };
            store_1.inventoryOrderStore.intentOrderMeta = generateIntentOrderMeta;
            // action log generate quick order trigger.
            const logData = {
                action: `Generate inventory order for intent claim. (Claim quantity: ${claimQuantity}) (Inventory: ${inventory.strengthDescription}) (Site: ${site.name})`,
                category: store_8.LogCategory.claim,
                categoryReferenceKey: claim.id,
                order: claim.orderId || (claim.order && claim.order.id) || null,
                site: site.id,
                user: store_8.usersStore.user.value.id
            };
            await store_7.auditLoggerStore.auditLog(logData);
            router_1.RouteManager.transitionTo("/order/quickorder");
        };
        this.resetChangedClaims = () => {
            this.changedClaims = [];
        };
        this.renderAddLotUi = () => {
            const { lotNumber, expireDate, quantity } = this.newLot;
            const shouldDisableNewLotSave = !lotNumber || !expireDate || (!quantity && quantity !== 0);
            const { name = "", displayName = "" } = this.claim.order.site;
            const { inventory } = this.claim;
            return (React.createElement(modal_1.Modal, { onCancel: () => {
                    this.createLotShow = false;
                } },
                React.createElement("div", { className: "lot-add-form-container" },
                    React.createElement("div", null,
                        React.createElement(material_ui_1.Typography, { variant: "display1" }, "Create Lot"),
                        React.createElement("div", { className: "lot-add-form-container__site" },
                            React.createElement(material_ui_1.Typography, { variant: "body2" }, name || displayName)),
                        React.createElement("div", { className: "lot-add-form-container__inventory" },
                            React.createElement(material_ui_1.Typography, { variant: "caption" },
                                inventory.group,
                                " |",
                                " ",
                                inventory.strengthDescription || inventory.name),
                            React.createElement(material_ui_1.Typography, { variant: "caption" },
                                inventory.package,
                                " | ",
                                inventory.dosage))),
                    React.createElement("div", { className: "lot-add-form" },
                        React.createElement(text_field_1.MaterialTextField, { className: "lot-add-form__item lot-add-form__lot-number", label: "Lot #", onChange: this.handleNewLotChange("lotNumber"), value: this.newLot.lotNumber }),
                        React.createElement(date_picker_1.MaterialDatePicker, { className: "lot-add-form__item lot-add-form__expire-date", label: "Expiration Date", onChange: this.handleNewLotDateChange("expireDate"), value: this.newLot.expireDate || new Date() }),
                        React.createElement(text_field_1.MaterialTextField, { className: "lot-add-form__item lot-add-form__qty", label: "Qty", onChange: this.handleNewLotChange("quantity"), required: true, type: "number", numType: "integer", value: this.newLot.quantity })),
                    React.createElement(button_1.MaterialButton, { flat: true, primary: true, disabled: shouldDisableNewLotSave, className: "lot-add-form__btn", onClick: this.handleNewLotCreate }, "Create Lot"))));
        };
        /**
         * Create a new lot, save it to the db, then query for the new claim to update
         * the current one.
         */
        this.handleNewLotCreate = async () => {
            const { inventory } = this.claim;
            const { site } = this.claim.order;
            if (!site) {
                throw new Error("Cannot create lot. No site found");
            }
            if (!inventory) {
                throw new Error("Cannot create lot. No inventory found");
            }
            const newLotMeta = {
                inventoryId: inventory.id,
                newLot: Object.assign({}, this.newLot),
                siteId: site.id
            };
            await store_2.inventoryListStore.addInventorySiteLot(newLotMeta);
            const claim = await store_3.ordersStore.readUpdatedClaim(this.claim.id);
            if (claim) {
                this.claim = ramda_1.merge(this.claim, {
                    inventory: claim.inventory
                });
                this.updateChangedClaims(this.claim);
                this.props.handleClaimChanged(this.changedClaims);
            }
            this.resetNewLot();
            this.createLotShow = false;
        };
        this.resetNewLot = () => {
            this.newLot = {
                expireDate: new Date(),
                lotNumber: "",
                quantity: 0
            };
        };
        this.handleNewLotChange = (field) => async (event, value) => {
            if (field === "lotNumber" || field === "quantity") {
                this.newLot[field] = value;
            }
        };
        this.handleNewLotDateChange = (field) => (value) => {
            if (field === "expireDate") {
                const formattedDate = this.formatDate(value);
                this.newLot.expireDate = formattedDate;
            }
        };
        this.renderClaimLotSelectionPreview = (selectedClaimLots) => {
            const lotPreviewColumns = [
                {
                    id: "lot",
                    label: "lot #"
                },
                {
                    id: "expDate",
                    label: "exp date"
                },
                {
                    id: "qty",
                    label: "lot qty"
                },
                {
                    id: "qtyUse",
                    label: "qty to use"
                }
            ];
            /**
             * @desc Updates a claim lot to hold the quantity to be used.
             * @param value Value from input.
             * @param index Index of the claimLot on the claim.
             */
            const updateQty = async (value, max, index) => {
                let valueLocal = value;
                const claimQty = this.claim.quantity;
                const { claimLots } = this.claim;
                const spent = claimLots.reduce((acc, cur) => acc + cur.qtyUsed, 0);
                if (valueLocal > claimQty + 1)
                    valueLocal = 0; // Attempt to repair potentially broken inputs.
                if (valueLocal < 0 || valueLocal > max) {
                    return;
                } // Can't use more than available or less than 0.
                if (spent === claimQty && valueLocal >= claimLots[index].qtyUsed) {
                    return;
                } // Can't add more than max.
                const original = Object.assign({}, this.claim);
                this.claim.claimLots[index].qtyUsed = valueLocal;
                this.claim = ramda_1.merge(original, this.claim);
                await this.saveClaim(this.claim);
                this.updateChangedClaims(this.claim);
            };
            /** Is this being used anywhere? */
            const renderLotExp = (lotOption, index) => {
                const inventorySiteLot = JSON.parse(lotOption.value);
                return (React.createElement(list_item_1.MaterialListItem, { className: "lot-selection-table", key: index },
                    React.createElement(list_item_text_1.MaterialListItemText, { className: "lot-selection-table__lot", primary: inventorySiteLot.lotNumber }),
                    React.createElement(list_item_text_1.MaterialListItemText, { className: "lot-selection-table__exp-date", primary: moment(inventorySiteLot.expirationDate).format("M-D-YYYY") }),
                    React.createElement(list_item_text_1.MaterialListItemText, { className: "lot-selection-table__qty", primary: inventorySiteLot.quantity }),
                    React.createElement(list_item_text_1.MaterialListItemText, { className: "lot-selection-table__qty--to-use", primary: React.createElement(material_ui_1.TextField, { type: "number", id: "standard-with-placeholder", label: "", value: (this.claim.claimLots.length &&
                                Number(this.claim.claimLots[index].qtyUsed)) ||
                                "", placeholder: "0", 
                            // style={{ width: "4em" }}
                            onChange: async (e) => updateQty(Number(e.currentTarget.value), inventorySiteLot.quantity, index) }) })));
            };
            return (React.createElement(list_1.MaterialList, { unstickHeader: true, columns: lotPreviewColumns, rows: selectedClaimLots, renderRow: this.renderLotExp }));
        };
        /**
         * @desc Updates a claim lot to hold the quantity to be used.
         * @param value Value from input.
         * @param index Index of the claimLot on the claim.
         */
        this.updateQty = async (value, max, index) => {
            let valueLocal = value;
            const claimQty = this.claim.quantity;
            const { claimLots } = this.claim;
            const spent = claimLots.reduce((acc, cur) => acc + cur.qtyUsed, 0);
            if (valueLocal > claimQty + 1)
                valueLocal = 0; // Attempt to repair potentially broken inputs.
            if (valueLocal < 0 || valueLocal > max) {
                return;
            } // Can't use more than available or less than 0.
            if (spent === claimQty && valueLocal >= claimLots[index].qtyUsed) {
                return;
            } // Can't add more than max.
            const original = Object.assign({}, this.claim);
            this.claim.claimLots[index].qtyUsed = valueLocal;
            this.claim = ramda_1.merge(original, this.claim);
            await this.saveClaim(this.claim);
            this.updateChangedClaims(this.claim);
        };
        this.renderLotExp = (lotOption, index) => {
            const inventorySiteLot = JSON.parse(lotOption.value);
            const { claimLot } = lotOption;
            console.info("lotOption in renderLotExp is", lotOption);
            console.info("this.claim", this.claim);
            return (React.createElement(list_item_1.MaterialListItem, { className: "lot-selection-table", key: index },
                React.createElement(list_item_text_1.MaterialListItemText, { className: "lot-selection-table__lot", primary: inventorySiteLot.lotNumber }),
                React.createElement(list_item_text_1.MaterialListItemText, { className: "lot-selection-table__exp-date", primary: moment(inventorySiteLot.expirationDate).format("M-D-YYYY") }),
                React.createElement(list_item_text_1.MaterialListItemText, { className: "lot-selection-table__qty", primary: inventorySiteLot.quantity }),
                React.createElement(list_item_text_1.MaterialListItemText, { className: "lot-selection-table__qty--to-use", primary: React.createElement(material_ui_1.TextField, { type: "number", id: "standard-with-placeholder", label: "", 
                        // value={
                        //   (this.claim.claimLots.length &&
                        //     Number(this.claim.claimLots[index].qtyUsed)) ||
                        //   ""
                        // }
                        value: claimLot ? claimLot.qtyUsed : "", placeholder: "0", 
                        // style={{ width: "4em" }}
                        onChange: async (e) => this.updateQty(Number(e.currentTarget.value), inventorySiteLot.quantity, index) }) })));
        };
        /**
         * @desc Renders the edit dropdown.
         */
        this.renderChildRowEditMode = (child) => {
            const statError = child.status === claim_1.ClaimStatus.Error;
            const statNew = child.status === claim_1.ClaimStatus.New;
            const statRevError = child.status === claim_1.ClaimStatus.ReverseError;
            const statRev = child.status === claim_1.ClaimStatus.Reversed;
            const validClaim = !statError && !statNew && !statRevError && !statRev;
            return (this.props.order &&
                this.props.order.auditStatus === order_1.AuditStatus.Approved && (React.createElement("div", { key: -1 }, validClaim &&
                ((this.checkedClaimId === this.editClaimId &&
                    this.editClaimId === child.id) ||
                    (this.editClaimId === child.id && !this.isCollapse)) && (React.createElement("div", { className: "edit-claiminfo", key: -1 },
                React.createElement("div", { className: "list-component__row" }, this.renderClaimInfo(child)))))));
        };
        this.renderGroupedListChild = (claim, groupIndex, rowIndex, topPriority) => {
            var _a, _b, _c, _d;
            const noCheckbox = this.noCheckbox();
            const disableCheckbox = claim.status !== claim_1.ClaimStatus.Paid;
            const { order } = this.props;
            const { site } = order;
            const invSite = claim.inventory.sites.find((invSite) => invSite.siteId === site.id);
            const isLive = order.type === 0;
            const hasPriority = claim.inventory.priority !== 0;
            const isTopPriority = claim.inventory.priority === topPriority;
            const isPaid = claim.status === claim_1.ClaimStatus.Paid;
            const isError = claim.status === claim_1.ClaimStatus.Error;
            const dispenseFee = claim.dispenseFeeAmount;
            const drugCost = claim.price * 100; // Is decimal in DB.
            const drugTotal = claim.quantity * drugCost;
            const imbCut = Number(site.imbFee) / 100; // Is non-decimal in DB.
            const pharmPrice = !!invSite ? invSite.price * 100 * claim.quantity : 0; // Is decimal in DB.
            const cAmount = claim.copayAmount || 0;
            const pAmount = isLive ? (_b = (_a = claim.copay) === null || _a === void 0 ? void 0 : _a.newPatientAmount) !== null && _b !== void 0 ? _b : claim.patientAmount : drugTotal;
            const tAmount = isLive ? claim.totalAmount : drugTotal;
            const imbProfit = tAmount * imbCut;
            const minProfit = !!site.minProfit ? site.minProfit * 100 : 0; // Is decimal in DB.
            const hasProfitData = !!claim.profitData;
            /** The remaining amount after we subtract IMB's fee, the dispensing fee,
             * and the cost of the drugs. This number is being stored as a non-decimal
             * value (ex. 17500 = $175.00).
             * dispensing fee should not be taken out of calculation
             */
            const rawProfit = isLive
                ? hasProfitData
                    ? claim.profitData.profit
                    : tAmount - imbProfit - drugTotal
                : pAmount - pharmPrice;
            const hideLow = claim.status === claim_1.ClaimStatus.Paid ||
                claim.status === claim_1.ClaimStatus.ReverseError ||
                claim.status === claim_1.ClaimStatus.ReverseErrorDev ||
                claim.status === claim_1.ClaimStatus.Reversed;
            if (!store_8.usersStore.permissions.ReadErrors) {
                const isTooLow = hasProfitData
                    ? !claim.profitData.profitable
                    : !!rawProfit
                        ? rawProfit < minProfit
                        : true;
                if (isError || (isTooLow && hideLow))
                    return null;
            }
            const toPrice = (cost) => cost / 100;
            const meetsMin = hasProfitData
                ? claim.profitData.profitable
                : rawProfit >= minProfit && rawProfit !== 0;
            const pharmProfit = `$ ${toPrice(hasProfitData ? claim.profitData.profit : rawProfit).toFixed(2)}`;
            const lowMsg = claim.ingredientCost || order.type === order_1.OrderType.Cash ? "Too Low" : ""; // Only previously paid claims have an ingredientCost attached.
            const copayAmount = cAmount
                ? `$ ${toPrice(cAmount).toFixed(2)}`
                : "$0.00";
            const patientAmount = !isLive || (isLive && claim.ingredientCost)
                ? `$ ${toPrice(pAmount).toFixed(2)}`
                : "";
            const pharmAmount = meetsMin ? pharmProfit : lowMsg;
            const totalAmount = tAmount
                ? `$ ${toPrice(tAmount).toFixed(2)}`
                : "";
            const showRetryButton = (order &&
                order.status !== order_1.OrderStatus.Done &&
                order.status !== order_1.OrderStatus.Refilled &&
                order.status !== order_1.OrderStatus.Reversed &&
                order.status !== order_1.OrderStatus.ReverseError &&
                claim.status === claim_1.ClaimStatus.Error) ||
                claim.status === claim_1.ClaimStatus.ReverseError;
            const showPrintLabelButton = (claim.status === claim_1.ClaimStatus.Dispensed ||
                claim.status === claim_1.ClaimStatus.Refill ||
                claim.status === claim_1.ClaimStatus.RefillDelayed ||
                claim.status === claim_1.ClaimStatus.RefillDone ||
                claim.status === claim_1.ClaimStatus.Refilled) &&
                store_8.usersStore.permissions.ReadPrint;
            const showResponseButton = (((_c = claim === null || claim === void 0 ? void 0 : claim.responses) === null || _c === void 0 ? void 0 : _c.length) || ((_d = claim === null || claim === void 0 ? void 0 : claim.requests) === null || _d === void 0 ? void 0 : _d.length)) &&
                store_8.usersStore.permissions.ReadResponses;
            const showRefillButtons = claim.status === claim_1.ClaimStatus.Refill ||
                claim.status === claim_1.ClaimStatus.RefillDelayed;
            const showUndoButton = (claim.status === claim_1.ClaimStatus.Dispensed ||
                claim.status === claim_1.ClaimStatus.Intended) &&
                store_8.usersStore.permissions.CreateClaims;
            /** Dont use ?? here, no idea why the linter is suggesting this. */
            const showMenuButton = showRetryButton ||
                showPrintLabelButton ||
                showResponseButton ||
                showUndoButton;
            console.log(showMenuButton);
            const siteInventory = claim === null || claim === void 0 ? void 0 : claim.inventory.sites.find((invSite) => invSite.siteId === order.site.id);
            const siteQty = siteInventory === null || siteInventory === void 0 ? void 0 : siteInventory.quantity;
            const canFill = siteQty && siteQty >= claim.quantity;
            const getGetOrdinal = (n) => {
                const s = ["th", "st", "nd", "rd"];
                const v = n % 100;
                return String(n) + (s[(v - 20) % 10] || s[v] || s[0]);
            };
            if (store_8.usersStore.user.value.siteUser) {
                // ordersStore.claimsGroup.value.filter((claim: any) => {
                const stat = claim.status;
                if (stat === claim_1.ClaimStatus.Error ||
                    stat === claim_1.ClaimStatus.New ||
                    stat === claim_1.ClaimStatus.Reversed ||
                    stat === claim_1.ClaimStatus.ReverseError) {
                    return null;
                    // return;
                }
                // });
            }
            const cStatus = claim.status;
            const priorityClass = cStatus === claim_1.ClaimStatus.Error || cStatus === claim_1.ClaimStatus.ReverseError
                ? "priority__error"
                : cStatus === claim_1.ClaimStatus.Reversed ||
                    cStatus === claim_1.ClaimStatus.ReverseErrorDev
                    ? "priority__reversed"
                    : "priority";
            const isDev = store_8.usersStore.user.value.groupId === permissions_1.GROUPS.DEV;
            const inventoryName = claim.inventory.strengthDescription ||
                claim.inventory.name ||
                claim.inventory.generic;
            /**
             * #TODO E-035, E-046(ReadInsurancePayment) total amount bind in $ "INS REIM" colums
             */
            return [
                React.createElement(list_item_1.MaterialListItem, { className: priorityClass, key: rowIndex, onClick: () => this.handleClickChild(claim, rowIndex) },
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: React.createElement(React.Fragment, null,
                            noCheckbox ? (React.createElement("span", null)) : (React.createElement(checkbox_1.MaterialCheckbox, { disabled: disableCheckbox, 
                                // checked={isTopPriority && !disableCheckbox
                                checked: isPaid ? this.props.isClaimChecked(claim) : false, label: "", onAction: () => {
                                    this.handleCheckChild(claim);
                                } })),
                            `${claim.rxId ? claim.rxId.rxId : claim.id}-${claim.fillNumber}`) }),
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: hasPriority &&
                            getGetOrdinal(claim.inventory.priority) + (((isTopPriority && " (Top)") || "")) }),
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: claim.inventory.package }),
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: uppercase_string_1.uppercaseString(inventoryName) }),
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: claim.quantity }),
                    store_8.usersStore.permissions.ReadInsurancePayment && (React.createElement(list_item_text_1.MaterialListItemText, { primary: totalAmount })),
                    store_8.usersStore.permissions.ReadProfit && (React.createElement(list_item_text_1.MaterialListItemText, { primary: pharmAmount })),
                    store_8.usersStore.permissions.ReadCopay && (React.createElement(list_item_text_1.MaterialListItemText, { primary: patientAmount })),
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: React.createElement("div", { className: "material-list-item-text claimstatus", "data-tip": claim.status === claim_1.ClaimStatus.Paid
                                ? claim.authorizationNumber &&
                                    `Authorization #: ${claim.authorizationNumber}`
                                : claim.message },
                            React.createElement("div", { className: "order-claims__row" },
                                React.createElement("div", { className: `order-claims__status order-claims__status--${claim.status}` }),
                                React.createElement("div", { className: "orders-claims__status-text" },
                                    claim.status === claim_1.ClaimStatus.Dispensed && "Dispensed",
                                    claim.status === claim_1.ClaimStatus.Intended &&
                                        (!canFill ? "Intend to Dispense" : "Now Available"),
                                    claim.status === claim_1.ClaimStatus.Error &&
                                        (claim.cancelReason ? "Rejected" : "Error"),
                                    claim.status === claim_1.ClaimStatus.ReverseErrorDev && "ERX Error",
                                    claim.status === claim_1.ClaimStatus.Paid &&
                                        (order && order.type === order_1.OrderType.Cash
                                            ? // ? "Approved (Cash)"
                                                "Approved"
                                            : "Approved"),
                                    claim.status === claim_1.ClaimStatus.Refill && "Refill Due",
                                    claim.status === claim_1.ClaimStatus.RefillDelayed &&
                                        "Refill Delayed",
                                    claim.status === claim_1.ClaimStatus.RefillDone && "Refilled",
                                    claim.status === claim_1.ClaimStatus.Refilled && "Refilled",
                                    claim.status === claim_1.ClaimStatus.Reversed &&
                                        (claim.cancelReason
                                            ? claim.cancelReason.includes("Rejected")
                                                ? "Rejected"
                                                : "Claim Reversed"
                                            : "Cancelled"),
                                    claim.status === claim_1.ClaimStatus.ReverseError &&
                                        !isDev &&
                                        "Pending Reversal",
                                    claim.status === claim_1.ClaimStatus.ReverseError &&
                                        isDev &&
                                        "Failed to Reverse",
                                    !canFill &&
                                        claim.status === claim_1.ClaimStatus.Paid && (React.createElement(Warning_1.default, { className: "warning", "data-tip": "Out of stock - will be marked as Intend to Dispense", "data-place": "right" }))))) }),
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: React.createElement("div", { className: "material-list-item-menu" },
                            showMenuButton && (React.createElement(button_1.MaterialButton, { flat: true, className: "row-menu-btn", onClick: (event) => this.onClickMenu(event, groupIndex, rowIndex) },
                                React.createElement(MoreVert_1.default, null))),
                            React.createElement(menu_1.MaterialMenu, { open: Boolean(this.menuOpen[`${groupIndex}-${rowIndex}`]), onClose: () => this.onCloseMenu(groupIndex, rowIndex), anchorEl: this.menuOpen[`${groupIndex}-${rowIndex}`] },
                                showRetryButton && (React.createElement(Menu_1.MenuItem, { onClick: async () => this.onClickMenuItem(claim, groupIndex, rowIndex, 0) }, claim.status === claim_1.ClaimStatus.Error
                                    ? "Retry Claim"
                                    : "Retry Reversal")),
                                showPrintLabelButton && (React.createElement(Menu_1.MenuItem, { onClick: async () => {
                                        await this.onClickMenuItem(claim, groupIndex, rowIndex, 1);
                                    } }, "Print Labels")),
                                showUndoButton && (React.createElement(Menu_1.MenuItem, { onClick: async () => {
                                        await this.undoDispense(claim);
                                    } }, claim.status === claim_1.ClaimStatus.Dispensed
                                    ? "Undo Dispense"
                                    : "Mark as Ready")),
                                claim.status === claim_1.ClaimStatus.Intended && (React.createElement(Menu_1.MenuItem, { onClick: async () => this.cancelIntentClaim(claim) }, "Cancel Intent")),
                                showResponseButton && (React.createElement(Menu_1.MenuItem, { onClick: async () => this.onClickMenuItem(claim, groupIndex, rowIndex, 2) }, "View All Claim Data")),
                                showRefillButtons && (React.createElement(Menu_1.MenuItem, { onClick: async () => this.onClickMenuItem(claim, groupIndex, rowIndex, 3) }, "Process Refill")),
                                showRefillButtons &&
                                    claim.status !== claim_1.ClaimStatus.RefillDelayed && (React.createElement(Menu_1.MenuItem, { onClick: async () => this.onClickMenuItem(claim, groupIndex, rowIndex, 4) }, "Delay Refill")),
                                showRefillButtons && (React.createElement(Menu_1.MenuItem, { onClick: async () => this.onClickMenuItem(claim, groupIndex, rowIndex, 5) }, "Cancel Refills")),
                                claim.status === claim_1.ClaimStatus.Error && order.refill && (React.createElement(Menu_1.MenuItem, { onClick: async () => this.onClickMenuItem(claim, groupIndex, rowIndex, 6) }, "Find Alternative")))) })),
                this.renderChildRowEditMode(claim)
            ];
        };
        this.renderGroupedListRow = (row, index) => {
            /** @returns The top priority excluding zeros. */
            const priorities = row.children.map((claim) => {
                const { priority } = claim.inventory;
                return priority !== 0 ? priority : Infinity;
            });
            const topPriority = Math.min(...priorities);
            const groupedRows = row.children
                .map((claim, rowIndex) => this.renderGroupedListChild(claim, index, rowIndex, topPriority))
                .filter((claimRow) => !!claimRow);
            let filteredRow = [];
            if (store_8.usersStore.user.value.siteUser) {
                filteredRow = row.children.filter((claim) => {
                    const stat = claim.status;
                    return (stat !== claim_1.ClaimStatus.Error &&
                        stat !== claim_1.ClaimStatus.New &&
                        stat !== claim_1.ClaimStatus.Reversed &&
                        stat !== claim_1.ClaimStatus.ReverseError);
                });
                if (filteredRow.length === 0 || groupedRows.length === 0) {
                    if (index === store_3.ordersStore.claimsGroup.value.length - 1 &&
                        this.renderedGroups === 0) {
                        return (React.createElement("div", { key: "0" },
                            React.createElement(list_item_1.MaterialListItem, { className: "no-rows" }, "No medications available.")));
                    }
                    return React.createElement("div", { key: index });
                }
                this.renderedGroups++;
            }
            return (React.createElement("div", { key: index },
                React.createElement(list_item_1.MaterialListItem, { category: list_item_1.IListItemCategory.GroupHeader, onClick: () => {
                        this.handleClickGroup(index);
                    } },
                    React.createElement(list_item_text_1.MaterialListItemText, { groupHeader: true, primary: `${row.group || CONFIG.emptyText}` })),
                React.createElement(Collapse_1.default, { className: this.showChildren[index] !== false ? "collapse" : "", in: this.showChildren[index] !== false },
                    React.createElement(list_1.MaterialList, { rows: groupedRows, renderRow: (claimRow) => claimRow }))));
        };
        this.renderTableBlankRow = () => {
            const { order } = this.props;
            let timeRemaining = "";
            if (order) {
                const now = moment();
                const appt = moment(order.createDate);
                const diff = appt.diff(now);
                const duration = moment.duration(appt.diff(now));
                const days = appt.diff(now, "days");
                if (diff > 0) {
                    if (days > 0) {
                        timeRemaining = `${timeRemaining} ${days}d`;
                    }
                    timeRemaining = `${timeRemaining} ${duration
                        .hours()
                        .toString()
                        .padStart(2, "0")}:${duration
                        .minutes()
                        .toString()
                        .padStart(2, "0")}:${duration
                        .seconds()
                        .toString()
                        .padStart(2, "0")}`;
                }
                else {
                    timeRemaining = "";
                }
            }
            let message = "No medications available: pharmacy or insurance lack coverage.";
            const oStatus = this.props.order.status;
            const blacklistFallbackMessage = "Claim not processed due to patient's insurance being on the Insurance Blacklist";
            const neutralReversedFallbackMessage = "Pending claim was canceled.";
            const hasNdcBlacklistReversedClaim = (store_3.ordersStore.claimsGroup.value || [])
                .flatMap((row) => row.children || [])
                .some((claim) => {
                const msg = (claim.message || "").toLowerCase();
                return (claim.status === claim_1.ClaimStatus.Reversed &&
                    msg.includes("insurance blacklist"));
            });
            if (oStatus === order_1.OrderStatus.Reversed) {
                message =
                    this.props.order.message ||
                        (hasNdcBlacklistReversedClaim
                            ? blacklistFallbackMessage
                            : neutralReversedFallbackMessage);
            }
            if (oStatus === order_1.OrderStatus.Progress) {
                message = "Claim transmitting now.";
            }
            if (oStatus === order_1.OrderStatus.Pending) {
                message =
                    timeRemaining === ""
                        ? "Claim waiting to transmit."
                        : `Claim Pending. Will transmit in ${timeRemaining}`;
            }
            return React.createElement(list_item_1.MaterialListItem, { className: "no-rows" }, message);
        };
        this.onRequestSort = async (property) => {
            if (this.orderBy === property) {
                this.order === "ASC" ? (this.order = "DESC") : (this.order = "ASC");
            }
            else {
                this.orderBy = property;
                this.order = "ASC";
            }
            await this.loadClaims();
        };
        this.loadClaims = async () => {
            const options = {
                count: 200,
                order: this.order,
                sort: this.orderBy,
                start: 0,
                where: ""
            };
            const orderId = this.props.order ? this.props.order.id : 0;
            await store_3.ordersStore.loadClaims(orderId, options);
        };
        this.handleChangeDate = (value) => {
            const formattedDate = this.formatDate(value);
            this.claim = ramda_1.merge(this.claim, { expireDate: formattedDate });
            this.updateChangedClaims(this.claim);
            this.props.handleClaimChanged(this.changedClaims);
            this.expireDate = formattedDate;
        };
        this.handleChangeString = (fieldName) => (event, value) => {
            this.claim = ramda_1.merge(this.claim, { [fieldName]: value });
            this.updateChangedClaims(this.claim);
            this.props.handleClaimChanged(this.changedClaims);
        };
        // This method may be an appropriate place to push claims to a claims array in the store
        // for multi printing purposes.
        this.handleCheckChild = (claim) => {
            this.isCollapse = false;
            this.checkedClaimId = claim.id;
            this.props.handleClaimSelected(claim);
            store_3.ordersStore.addPrintClaim(this.claim);
        };
        this.handleClickGroup = (index) => {
            this.showChildren = ramda_1.merge(this.showChildren, {
                [index]: this.showChildren[index] === false
            });
        };
        this.handleClickChild = (child, index) => {
            if (this.editClaimId === child.id) {
                this.isCollapse = !this.isCollapse;
            }
            else {
                this.isCollapse = false;
            }
            this.checkedClaimId = -1;
            this.editClaimId = child.id;
            this.currentRowIndex = index;
            const indexChangedClaims = this.changedClaims.findIndex(c => c.id === child.id);
            this.claim =
                indexChangedClaims === -1
                    ? child
                    : this.changedClaims[indexChangedClaims];
        };
        this.handleClaimResponseCancel = () => {
            // this.showClaimResponse = false;
            // C-122
            try {
                window.opener = null; // In case this is a popup
                window.open("", "_self", "");
                window.close();
            }
            catch (e) {
                console.log("This window can't be closed");
            }
        };
        this.updateChangedClaims = (claim) => {
            const index = this.changedClaims.findIndex(c => c.id === claim.id);
            if (index !== -1) {
                this.changedClaims.splice(index, 1);
            }
            this.changedClaims.push(claim);
        };
        this.undoDispense = async (claim) => {
            await store_3.ordersStore.undoDispense(claim);
            await store_3.ordersStore.loadClaims(claim.orderId);
            await store_3.ordersStore.readOrder(claim.orderId);
        };
        this.cancelIntentClaim = async (claim) => {
            await store_3.ordersStore.cancelIntentClaim(claim);
            await store_3.ordersStore.loadClaims(claim.orderId);
            await store_3.ordersStore.readOrder(claim.orderId);
        };
        this.saveClaim = async (claim) => {
            await store_3.ordersStore.updateClaim(claim);
        };
    }
    get availableLots() {
        const siteId = this.claim.order.site.id;
        const siteInventory = this.claim.inventory.sites.find(inventorySite => inventorySite.siteId === siteId &&
            inventorySite.inventoryId === this.claim.inventory.id);
        const availableLots = (siteInventory === null || siteInventory === void 0 ? void 0 : siteInventory.inventorySiteLots) ? siteInventory.inventorySiteLots
            .filter((invSiteLot) => {
            const expDate = moment(invSiteLot.expirationDate);
            const expired = moment().isAfter(expDate);
            return !expired;
        })
            .map((invSiteLot) => {
            const expDate = moment(invSiteLot.expirationDate);
            return {
                id: invSiteLot.id,
                label: `${invSiteLot.lotNumber} (Exp. ${expDate.format("MM/DD/YY")})`,
                value: JSON.stringify(invSiteLot)
            };
        })
            : [];
        // C-112 for lot # comment the below line
        // return availableLots;
        return availableLots.filter((val) => {
            const jsonConvert = JSON.parse(val.value);
            if (parseInt(jsonConvert.quantity) > 0) {
                return val;
            }
            else {
                return val = "";
            }
        });
    }
    async componentDidMount() {
        const { order } = this.props;
        if (order) {
            await store_3.ordersStore.loadActivePads(order);
        }
        await store_5.providersStore.loadProviders();
        //C-122
        const queryParams = new URLSearchParams(window.location.search);
        const id = queryParams.get("id");
        if (id) {
            await this.getErxDataOnView(id);
        }
    }
    componentWillUnmount() {
        if (this.signatureInterval) {
            window.clearInterval(this.signatureInterval);
        }
    }
    async componentDidUpdate() {
        ReactTooltip.rebuild();
        if (!this.patient && this.props.order) {
            this.patient = await store_4.patientsStore.readPatient(this.props.order.patient.id);
        }
    }
    noCheckbox() {
        const noCheckbox = this.props.order &&
            (this.props.order.status === order_1.OrderStatus.Done ||
                this.props.order.status === order_1.OrderStatus.Refilled ||
                this.props.order.status === order_1.OrderStatus.Reversed);
        return noCheckbox;
    }
    renderCheckAll() {
        if (!this.noCheckbox()) {
            return (React.createElement(checkbox_1.MaterialCheckbox, { onAction: () => {
                    this.props.handleCheckAllClaims();
                }, label: "", checked: this.props.isAllClaimsChecked(), indeterminate: this.props.indeterminate() }));
        }
        return React.createElement("div", null);
    }
    render() {
        var _a, _b, _c, _d, _e;
        const { order } = this.props;
        const permissionColumns = [];
        // C-122
        let viewClaimData;
        const queryParams = new URLSearchParams(window.location.search);
        const id = queryParams.get("id");
        const group = Number(queryParams.get("group"));
        if (id && order) {
            const claimData = (_c = (_b = (_a = store_3.ordersStore.claimsGroup) === null || _a === void 0 ? void 0 : _a.value[group]) === null || _b === void 0 ? void 0 : _b.children) === null || _c === void 0 ? void 0 : _c.filter((item) => item.id == id);
            if (claimData && claimData.length > 0) {
                viewClaimData = claimData[0];
            }
        }
        if (!this.rendered) {
            const insuranceColumn = {
                id: "claim.totalAmount",
                label: "INS REIM $".toUpperCase()
            };
            const profitColumn = {
                id: "pharmacyProfit",
                label: "pharm profit $".toUpperCase()
            };
            const copayColumn = {
                id: "patientCopay",
                label: "patient price $".toUpperCase()
            };
            this.rendered = true;
            if (store_8.usersStore.permissions.ReadInsurancePayment)
                permissionColumns.push(insuranceColumn);
            if (store_8.usersStore.permissions.ReadProfit) {
                permissionColumns.push(profitColumn);
            }
            if (store_8.usersStore.permissions.ReadCopay)
                permissionColumns.push(copayColumn);
            this.columns.splice(5, 0, ...permissionColumns);
        }
        if (!this.onRetryCLaim) {
            return (React.createElement("div", { style: { display: "float", marginLeft: "50%", top: "50%" } },
                React.createElement(ui_1.UiLoadingIndicator, null)));
        } // B-094.12
        return (React.createElement("div", { className: "order-claims" },
            (store_3.ordersStore.claimsGroup.error || store_3.ordersStore.errorAlert) && (React.createElement(alert_1.UiAlert, { title: "Error", type: "error", message: (_d = store_3.ordersStore.claimsGroup.error) !== null && _d !== void 0 ? _d : store_3.ordersStore.errorAlert })),
            order && (React.createElement("div", { className: "inventory__list" },
                React.createElement(ui_1.UiForm, { loading: this.props.loading },
                    React.createElement(list_1.MaterialList, { unstickHeader: true, checkbox: this.renderCheckAll(), columns: this.columns, menu: React.createElement("div", null), onRequestSort: this.onRequestSort, order: this.order, orderBy: this.orderBy, rows: (_e = store_3.ordersStore.claimsGroup.value) !== null && _e !== void 0 ? _e : [], renderRow: this.renderGroupedListRow, renderBlankRow: this.renderTableBlankRow, resizableheader: true, customClass: store_8.usersStore.permissions.ReadProfit
                            ? "custom-material-list__order-claims-list"
                            : "custom-material-list__order-claims-list--no-read" })))),
            viewClaimData && ( // C-122
            React.createElement(transaction_details_1.TransactionDetails, { claim: viewClaimData, erxLog: this.erxLogData, onCancel: this.handleClaimResponseCancel })),
            React.createElement(ReactTooltip, { effect: "solid", place: "left" }),
            this.selectedRefill && this.confirmRefill(),
            this.findAlternative && this.confirmFindAlternative()));
    }
    formatDate(date) {
        const currentDate = new Date(date);
        let month = String(currentDate.getMonth() + 1);
        let day = String(currentDate.getDate());
        const year = currentDate.getFullYear();
        if (month.length < 2) {
            month = `0${month}`;
        }
        if (day.length < 2) {
            day = `0${day}`;
        }
        return [year, month, day].join("-");
    }
};
__decorate([
    mobx_1.observable
], OrderClaims.prototype, "claim", void 0);
__decorate([
    mobx_1.observable
], OrderClaims.prototype, "changedClaims", void 0);
__decorate([
    mobx_1.observable
], OrderClaims.prototype, "menuOpen", void 0);
__decorate([
    mobx_1.observable
], OrderClaims.prototype, "showChildren", void 0);
__decorate([
    mobx_1.observable
], OrderClaims.prototype, "isCollapse", void 0);
__decorate([
    mobx_1.observable
], OrderClaims.prototype, "checkedClaimId", void 0);
__decorate([
    mobx_1.observable
], OrderClaims.prototype, "editClaimId", void 0);
__decorate([
    mobx_1.observable
], OrderClaims.prototype, "currentRowIndex", void 0);
__decorate([
    mobx_1.observable
], OrderClaims.prototype, "order", void 0);
__decorate([
    mobx_1.observable
], OrderClaims.prototype, "orderBy", void 0);
__decorate([
    mobx_1.observable
], OrderClaims.prototype, "padsOpen", void 0);
__decorate([
    mobx_1.observable
], OrderClaims.prototype, "pads", void 0);
__decorate([
    mobx_1.observable
], OrderClaims.prototype, "showClaimResponse", void 0);
__decorate([
    mobx_1.observable
], OrderClaims.prototype, "selectedRefill", void 0);
__decorate([
    mobx_1.observable
], OrderClaims.prototype, "selectedRefillUseCash", void 0);
__decorate([
    mobx_1.observable
], OrderClaims.prototype, "findAlternative", void 0);
__decorate([
    mobx_1.observable
], OrderClaims.prototype, "selectedAlternative", void 0);
__decorate([
    mobx_1.observable
], OrderClaims.prototype, "expireDate", void 0);
__decorate([
    mobx_1.observable
], OrderClaims.prototype, "erxLogData", void 0);
__decorate([
    mobx_1.observable
], OrderClaims.prototype, "claimLots", void 0);
__decorate([
    mobx_1.observable
], OrderClaims.prototype, "createLotShow", void 0);
__decorate([
    mobx_1.observable
], OrderClaims.prototype, "onRetryCLaim", void 0);
__decorate([
    mobx_1.observable
], OrderClaims.prototype, "newLot", void 0);
__decorate([
    mobx_1.observable
], OrderClaims.prototype, "patient", void 0);
__decorate([
    mobx_1.observable
], OrderClaims.prototype, "settings", void 0);
__decorate([
    mobx_1.computed
], OrderClaims.prototype, "availableLots", null);
OrderClaims = __decorate([
    mobx_react_1.observer
], OrderClaims);
exports.OrderClaims = OrderClaims;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/orders/modules/orders-detail/components/order-claims/order-claims.tsx
// module id = 3755
// module chunks = 0